import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { catchError, map, Observable, of } from 'rxjs';

import { NavigationService } from '@services/navigation.service';
import { Navigation } from '@models/strapi';

export const navigationResolver: ResolveFn<Navigation[]> = (route, state) => {
  const navigationService = inject(NavigationService);

  return navigationService.getData().pipe(
    map((response) => {
      return response;
    }),
    catchError((e) => {
      console.error('Nepodařilo se načíst navigaci: ' + state.url + ' - Error: ' + e.message);
      return of([]);
    }),
  );
};